var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mounted)?_c('page-template',{attrs:{"with-slot":"","toolbar":_vm.toolbar}},[_c('i-list',{ref:"settingsList",attrs:{"id":"settingsViewSettingsList","items":_vm.items,"tile":_vm.settingsTile()}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }